import React from 'react';
import Select from '../../../../components/common/Select';

const presets = [
    {
        label: 'Keitaro TDS',
        value: {
            id: 'keitaro',
            params:
                '?subid={w}&status={status}&sale_status=approved&lead_status=new&rejected_status=declined&payout={web_total}',
        }
    },
    {
        label: 'Adsbridge',
        value: {
            id: 'adsbridge',
            params:
                '?subid={w}&status={status}&sale_status=approved&lead_status=new&rejected_status=declined&payout={web_total}',
        }
    },
    {
        label: 'CPAtracker',
        value: {
            id: 'cpatracker',
            params:
                '?subid={w}&status={status}&sale_status=approved&lead_status=new&rejected_status=declined&payout={web_total}',
        }
    },
    {
        label: 'Bemob',
        value: {
            id: 'bemob',
            params:
                '?cid={s}&payout={web_total}&txid={order_id}&status={status}',
        }
    },
    {
        label: 'PeerClick',
        value: {
            id: 'peerclick',
            params:
                '?userid=0000&cid={subid1}&summ_total={summ_total}&status={status}',
        }
    },
];

const getLink = id => {
    switch (id) {
        case 'adsbridge':
            return 'http://jkarv.adsb4trk.com/trackpixel/track';
        case 'cpatracker':
            return 'http://jne1.ru/37300/p.php';
        case 'peerclick':
            return 'http://pstb.peerclicktrk.com/postback';
        case 'bemob':
            return 'http://3gmbv.bemobtrk.com/postback';
        default:
            return 'http://example.com/mystat.php';
    }
};

const prepareURL = ({ id, params }) => {
    const link = getLink(id);
    return link + params;
};

export default class GlobalPostbackPresets extends React.Component {
    state = {
        preset: {
            label: 'Keitaro TDS',
            value: {
                id: 'keitaro',
                params:
                    '?subid={w}&status={status}&sale_status=approved&lead_status=new&rejected_status=declined&payout={web_total}',
            }
        }
    }
    render() {

        const { onPresetApply, checked } = this.props;
        const { preset } = this.state;
        return (
            <div className="global-postback-presets">
                <Select
                    id="postback-presets"
                    name="presets"
                    disabled={!checked}
                    clearable={false}
                    value={preset}
                    onChange={(selected) => {
                        this.setState(() => {
                            return { preset: selected }
                        }, () => {
                            onPresetApply(prepareURL(selected.value))
                        })
                    }}
                    options={presets}
                    searchable={false}
                />
            </div>
        )
    }
}
